import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Slick from '@/plugins/slick';

export default {
    init() {
        Slick.init();
    },
};
